import { render } from "./Mismatched.vue?vue&type=template&id=6ec71c9a&scoped=true&ts=true"
import script from "./Mismatched.vue?vue&type=script&lang=ts"
export * from "./Mismatched.vue?vue&type=script&lang=ts"

import "./Mismatched.vue?vue&type=style&index=0&id=6ec71c9a&scoped=true&lang=css"

import exportComponent from "/home3/sli/web/public/resources/editorvue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ec71c9a"]])

export default __exports__